/* ============================================================
   SHIPROCKET PINCODE CHECKER
   Checks delivery serviceability and estimated date via
   Shiprocket API. Credentials are fetched at runtime.
   ============================================================ */

(function () {
  var WORKER_ENDPOINT = 'https://purple-rain-92ec.operations-f43.workers.dev/';

  function getDeliveryDate(deliveryPincode) {
    var url = WORKER_ENDPOINT + '?pincode=' + encodeURIComponent(deliveryPincode);
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // pick the fastest available courier's ETD
        var available = data.data && data.data.available_courier_companies;
        if (!available || available.length === 0) {
          return null; // not serviceable
        }
        // sort by estimated_delivery_days ascending
        available.sort(function (a, b) {
          return (a.estimated_delivery_days || 99) - (b.estimated_delivery_days || 99);
        });
        var best = available[0];
        if (best.etd) {
          return { dateStr: best.etd };
        }
        var days = parseInt(best.estimated_delivery_days || 5, 10);
        return { days: days };
      });
  }

  function addBusinessDays(days) {
    var date = new Date();
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) added++; // skip Sundays
    }
    return date.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  function setupChecker(inputSel, btnSel, resultSel) {
    var input  = document.querySelector(inputSel);
    var btn    = document.querySelector(btnSel);
    var result = document.querySelector(resultSel);
    if (!input || !btn || !result) return;

    function check() {
      var pincode = input.value.trim();
      if (!/^\d{6}$/.test(pincode)) {
        result.textContent = 'Please enter a valid 6-digit pincode.';
        result.style.color = '#c0392b';
        return;
      }
      btn.textContent = '...';
      btn.disabled = true;
      result.textContent = '';

      getDeliveryDate(pincode)
        .then(function (res) {
          btn.textContent = 'APPLY';
          btn.disabled = false;
          if (!res) {
            result.textContent = 'Delivery not available at this pincode.';
            result.style.color = '#c0392b';
          } else {
            var dateDisplay = res.dateStr ? res.dateStr : addBusinessDays(res.days);
            result.textContent = 'Estimated delivery by ' + dateDisplay + '.';
            result.style.color = '#27ae60';
          }
        })
        .catch(function () {
          btn.textContent = 'APPLY';
          btn.disabled = false;
          result.textContent = 'Standard delivery takes 5–7 business days.';
          result.style.color = '#27ae60';
        });
    }

    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
  }

  function init() {
    setupChecker('#pincode-input',     '#pincode-apply',     '#pincode-result');
    setupChecker('#pincode-input-mob', '#pincode-apply-mob', '#pincode-result-mob');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
